import React from 'react'
import Navbar from '@components/navbar/Navbar'
import Sidebar from '@components/sidebar/Sidebar'
import { AuthContext, AuthContextType } from '@contexts/authContext'
import { ProfileService } from '@services/index'
import 'react-toastify/dist/ReactToastify.css'

interface IProps {
    children?: React.ReactNode | React.ReactNode[]
    navbar?: boolean
    sidebar?: boolean
}

/**
 * General component for wrapping pages.
 * @param navbar - Indicates if page will have navbar (Default: true)
 * @param sidebar - Indicates if page will have sidebar (Default: true)
 */
export default function Container({ children, navbar = true, sidebar = true }: IProps): JSX.Element {
    const { setDataUser } = React.useContext(AuthContext) as AuthContextType

    async function init(): Promise<void> {
        const profileContext = await ProfileService.getDataUser()
        setDataUser(profileContext)
    }

    React.useEffect(() => {
        init()
    }, [])

    return (
        <div className="container-wrapper">
            {sidebar ? <Sidebar /> : null}
            <div className="content">
                {navbar ? <Navbar /> : null}
                <div className="page-content">{children}</div>
            </div>
        </div>
    )
}
